import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import styled from 'styled-components';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { TrueImpactTooltipOnClick } from '../ImpactSummary/QuestionTextTooltip';

const StyledDiv = styled.div`
  max-width: 350px;
  padding-left: ${SPACERS.large};
  .calculator-info-text {
    margin-top: ${SPACERS.tiny};
  }
  ol {
    padding-left: 18px;
    margin-top: ${SPACERS.tiny};
    margin-bottom: ${SPACERS.tiny};
  }
`;

export const VolunteerismTooltip: React.FC = () => (
  <StyledDiv>
    <TrueImpactText variant="body-bold" className="calculator-info-text">
      How do I figure out volunteer value per hour/unit?
    </TrueImpactText>
    <ol>
      <li>Collect the total hours your employees volunteered.</li>
      <li>Determine the type of work they did.</li>
      <li>
        Define the appropriate hourly value using the{' '}
        <a href="https://www.bls.gov/oes/current/oes_nat.htm" target="_blank">
          Bureau of Labor Statistics (BLS) wage rates page
        </a>{' '}
        (be sure to add an additional 15.7 percent for overhead costs).
      </li>
      <li>
        Multiply the number of hours volunteered by the hourly value of that
        work.
      </li>
    </ol>
  </StyledDiv>
);

export const ProBonoTooltip: React.FC = () => (
  <StyledDiv>
    <TrueImpactText variant="body-bold" className="calculator-info-text">
      How do I figure out pro bono value per hour/unit?
    </TrueImpactText>
  </StyledDiv>
);

export const DonatedGoodsTooltip: React.FC = () => (
  <StyledDiv>
    <TrueImpactText variant="body-bold" className="calculator-info-text">
      How do I figure out donated goods value per hour/unit?
    </TrueImpactText>
  </StyledDiv>
);

export const DonatedServicesTooltip: React.FC = () => (
  <StyledDiv>
    <TrueImpactText variant="body-bold" className="calculator-info-text">
      How do I figure out donated services value per hour/unit?
    </TrueImpactText>
  </StyledDiv>
);

interface BudgetDonationsTooltipsProps {
  text: string;
  className?: string;
}

const getTooltip = (text: string) => {
  switch (text) {
    case 'Volunteerism':
      return <VolunteerismTooltip />;
    case 'Pro bono':
      return <ProBonoTooltip />;
    case 'Donated goods':
      return <DonatedGoodsTooltip />;
    case 'Donated services':
      return <DonatedServicesTooltip />;

    default:
      return <></>;
  }
};

const BudgetDonationsTooltips: React.FC<BudgetDonationsTooltipsProps> = ({
  text,
  className,
}) => {
  return (
    <TrueImpactTooltipOnClick
      tooltipComponent={getTooltip(text)}
      className={className}
    >
      <FontAwesomeIcon icon={faCircleInfo} />
    </TrueImpactTooltipOnClick>
  );
};

export default BudgetDonationsTooltips;
